import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../hooks/UseAuthContext';

/**
 * Wraps any route that requires authentication.
 * - If logged in  → renders children normally
 * - If logged out → redirects to /login, preserving the
 *   intended destination so the user lands there after signing in
 */
export default function ProtectedRoute({ children }) {
  const { user } = useAuthContext();
  const location = useLocation();

  if (!user) {
    // Pass the attempted URL as state so Signin can redirect back after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}